export default __webpack_public_path__ + "static/media/warehouse.ffe93079.png";